export default function verifyPythonPlaygroundQuestionCorrectness({
  code,
  output,
  verificationOutputRegexes,
  verificationInputRegexes,
  expectError,
}: {
  code: string;
  output: string;
  verificationOutputRegexes: string[];
  verificationInputRegexes: string[];
  expectError: boolean | null;
}): {
  failedInputRegexes: string[];
  failedOutputRegexes: string[];
} {
  const codeString = code || '';

  const failedInputRegexes = verificationInputRegexes.filter((regex) => {
    return !new RegExp(regex, 'g').test(codeString);
  });

  const outputString = output || '';
  const pythonExceptionRegexString = '^Traceback \\(most recent call last\\)[\\s\\S]*Error:';
  const hasException = new RegExp(pythonExceptionRegexString, 'g').test(outputString);

  if (hasException) {
    return expectError
      ? {
        failedInputRegexes,
        failedOutputRegexes: [],
      } : {
        failedInputRegexes,
        failedOutputRegexes: [pythonExceptionRegexString],
      };
  }

  const failedOutputRegexes = verificationOutputRegexes.filter((regex) => {
    return !new RegExp(regex, 'g').test(outputString);
  });

  return {
    failedInputRegexes,
    failedOutputRegexes,
  };
}
